import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BixiLabelModule } from '@bixi/label-angular';
import { MPagePickerModule } from '@mining/ui/page-picker';
import { MPipesModule } from '@mining/ui/pipes';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MOperationsFullscreenComponent } from './operations-fullscreen.component';
import { MOperationsPaginationComponent } from './operations-pagination.component';
import { MOperationsRotationLeftComponent } from './operations-rotation-left.component';
import { MOperationsRotationRightComponent } from './operations-rotation-right.component';
import { MOperationsTemplateComponent } from './operations-template.component';
import { MOperationsTemplateService } from './operations-template.service';
import { MOperationsZoomComponent } from './operations-zoom.component';
import { MOperationsComponent } from './operations.component';
import { MOperationsDirective } from './operations.directive';

const buildInOperations = [
  MOperationsPaginationComponent,
  MOperationsRotationRightComponent,
  MOperationsRotationLeftComponent,
  MOperationsZoomComponent,
  MOperationsComponent,
  MOperationsDirective,
  MOperationsTemplateComponent,
  MOperationsFullscreenComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NzSpaceModule,
    NzDropDownModule,
    NzIconModule,
    NzToolTipModule,
    NzPopoverModule,
    NzDividerModule,
    MPagePickerModule,
    BixiLabelModule,
    NzSliderModule,
    NzOutletModule,
    NzCascaderModule,
    MPipesModule
  ],
  declarations: [...buildInOperations],
  exports: [...buildInOperations],
  providers: [MOperationsTemplateService]
})
export class MOperationsModule {}
